module.exports = __webpack_public_path__ + "images/ds-lda-instructor-jeff-li-1.webp";